// MVP 앱 설정 층 — 플러그인 켜고 끄기·params 덮기는 여기 한 줄 (ADR-048 D4 「기본값 → MVP 앱 설정 → 원격 설정」)
// 예: hello: { enabled: false }  /  hello: { params: { greeting: '반가워요' } }
import type { PluginConfigLayer } from '../ports/plugin-config';

// serial 첫판 (DEC-95): 무료 연재라 결제·광고 보상·AI 대화 견본은 끈다. hello 는 템플릿 견본이다
export const appPluginConfig: PluginConfigLayer = {
  hello: { enabled: false },
  pay: { enabled: false },
  'ad-reward': { enabled: false },
  llm: { enabled: false },
  // 로그인 상태는 모든 화면 머리말에 — 쓰기 화면에서 홈으로 돌아가지 않고 로그인한다
  auth: { params: { slot: 'app.header' } },
};
